import React from "react";
import { useAppSelector } from "../../../Redux/hooks";
import { Box, Typography } from "@mui/material";
import { EmptyMessageWrapper, QuestionListStyle } from "../question.style";
import QuestionItemTranslationWrapper from "./QuestionItemTranslationWrapper";

const DropArea: React.FC = () => {
  const questions = useAppSelector(
    (state) => state.questionTranslation.questions
  );

  return (
    <Box sx={QuestionListStyle}>
      {questions.length > 0 ? (
        questions.map((question, index) => (
          <QuestionItemTranslationWrapper
            key={question.id}
            index={index}
            question={question}
          />
        ))
      ) : (
        <EmptyMessageWrapper>
          <Typography variant="h3" color="grey">
            No questions added yet
          </Typography>
        </EmptyMessageWrapper>
      )}
    </Box>
  );
};

export default DropArea;
